var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconGoogle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "flat-color-icons:google"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M14.5357 6.69498H13.9987V6.66732H7.9987V9.33398H11.7664C11.2167 10.8863 9.7397 12.0007 7.9987 12.0007C5.7897 12.0007 3.9987 10.2097 3.9987 8.00065C3.9987 5.79165 5.7897 4.00065 7.9987 4.00065C9.01836 4.00065 9.94603 4.38532 10.6524 5.01365L12.538 3.12798C11.3474 2.01832 9.7547 1.33398 7.9987 1.33398C4.31703 1.33398 1.33203 4.31898 1.33203 8.00065C1.33203 11.6823 4.31703 14.6673 7.9987 14.6673C11.6804 14.6673 14.6654 11.6823 14.6654 8.00065C14.6654 7.55365 14.6194 7.11732 14.5357 6.69498Z",
    fill: "#FFC107"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M2.10156 4.89765L4.2919 6.50398C4.88456 5.03665 6.3199 4.00065 7.99956 4.00065C9.01923 4.00065 9.9469 4.38532 10.6532 5.01365L12.5389 3.12798C11.3482 2.01832 9.75556 1.33398 7.99956 1.33398C5.4389 1.33398 3.21823 2.77965 2.10156 4.89765Z",
    fill: "#FF3D00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M8.00141 14.6669C9.72341 14.6669 11.2881 14.0079 12.4711 12.9362L10.4077 11.1902C9.71592 11.7164 8.87056 12.0009 8.00141 12.0002C6.26741 12.0002 4.79507 10.8946 4.24041 9.35156L2.06641 11.0266C3.16974 13.1856 5.41041 14.6669 8.00141 14.6669Z",
    fill: "#4CAF50"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M14.537 6.69368H14V6.66602H8V9.33268H11.7677C11.5047 10.0715 11.0311 10.7171 10.4053 11.1897L10.4063 11.189L12.4697 12.935C12.3237 13.0677 14.6667 11.3327 14.6667 7.99935C14.6667 7.55235 14.6207 7.11602 14.537 6.69368Z",
    fill: "#1976D2"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconGoogle);
export default __webpack_public_path__ + "static/media/icon-google.681db6621b91ac71acb7487d83c61278.svg";
export { ForwardRef as ReactComponent };